/* eslint-disable no-console */

import environment from '@3plearning/resource';
import { appName } from './app-config.js';

class Resources {
    static createResource() {
        const env = Resources.env;
        const authenticationBaseUrl = window._env_.AuthenticationGatewayEndpoint;

        Resources.verifyAuthToken = env.resource('MathAZ')
            .baseUrl(authenticationBaseUrl)
            .service('sessions/{authToken}');
    
        /**
         * Resource(s) that get a particular configuration item
         */
        Resources.getConfigurationItem = async key => env.getConfigurationItem(key);
    }
    
    static async initialise(envName, credentials) {
        const env = environment(envName, appName);
        const location = window.location;
        const runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);

        if (runningOnDeveloperMachine) {
            if (credentials.authToken) {
                env.authToken = credentials.authToken;
            } else {
                env.setCredentials(credentials.username, credentials.password);
            }
        } else if (credentials.authToken) {
            env.authToken = credentials.authToken;
        } else if (credentials.username && credentials.password) {
            env.username = credentials.username;
            env.password = credentials.password;
        } else {
            // The caller should have provided a valid set of credentials, so
            // hopefully this will never happen.

            console.log('BasicResources.initialise() - to execute, we need either an authToken or' +
                ' a username/password pair.  The credentials object that was provided does not' +
                ' contain either.  So, expect things to fail badly :-(.');
        }
        
        Resources.env = env;
        Resources.createResource();

        return Resources.env;
    }
}

export default Resources;
